module.exports = __webpack_public_path__ + "static/media/epiglow-1.4d608b3c.jpg";